import contentControls from "./contentControlsService"
import { DICTATION_CONTENT_BLOCK as DICTATION_CONTENT_BLOCK_COLOR } from "@/constants/contentControlColors";
import { tryLoadProperties } from "@/util/wordUtil";

const add = (name, hideBoundingBox = false) => new Promise(resolve => {
    const title = `Dictation Content Block: ${name}`;
    const options = {
        placeholderText: title,
        color: DICTATION_CONTENT_BLOCK_COLOR,
        tag: name,
        hideBoundingBox
    };

    contentControls.insert(title, options, ({ contentControl, parentContentControl, context }) => {
        tryLoadProperties(context, contentControl, "id").then(() => {
            const retVal = { id: contentControl.id };

            if (parentContentControl) {
                retVal.parentId = parentContentControl.id;
            }

            resolve(retVal);
        });
    });
});

export default {
    add
}